import { IEmployment } from '@/Models/IEmployment';
import { ITypedValidationResult } from '@/Models/IValidationResult';
import { BaseApiService } from './base-api-service';

class employmentService extends BaseApiService {
    public constructor() {
		super('employment/');
    }

	public async getByPhaseId(phaseId: number): Promise<IEmployment[]> {
		return this.httpClient.get<IEmployment[]>(`GetByPhaseId/${phaseId}`).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getByCaseId(caseId: number): Promise<IEmployment[]> {
        return this.httpClient.get<IEmployment[]>(`GetByCaseId/${caseId}`).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }
    
	public async save(dto: IEmployment): Promise<ITypedValidationResult<IEmployment>> {
		return this.httpClient.post<ITypedValidationResult<IEmployment>>("save", dto).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
	}

	public async delete(id: number): Promise<void> {
		return this.httpClient.delete<void>(`delete/${id}`).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
	}
}

export const EmploymentService: employmentService = new employmentService();